import React from 'react';
import Skeleton from "react-loading-skeleton";
import styles from 'components/FoodCourt/FoodCourtItem.module.css';
function FoodCourtListItemSkeleton() {
    return(
        <>
            {Array.apply(0, Array(8)).map((n, i) => (
                <div className={styles.foodcourt_item} style={{lineHeight: 1}} key={i}>
                    <Skeleton height={207} />
                </div>
            ))}
        </>        
    );
}
export default FoodCourtListItemSkeleton;